module.exports = __webpack_public_path__ + "img/arrow-3.06320f33.png";